var React = require('react');

function Paused (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 0h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1z","fill":"#F3D200"}));
}

Paused.defaultProps = {"width":"8","height":"10","viewBox":"0 0 8 10"};

module.exports = Paused;

Paused.default = Paused;
